module.exports = __webpack_public_path__ + "static/media/Environment.11871b8f.png";